import Airtable from 'airtable'

require('dotenv').config()

const { VUE_APP_AIRTABLE_API_KEY, VUE_APP_AIRTABLE_BASE } = process.env

const api = new Airtable({
  apiKey: VUE_APP_AIRTABLE_API_KEY
}).base(VUE_APP_AIRTABLE_BASE)

const post = (table, record) => {
  return new Promise((resolve, reject) => {
    api(table).create(
      [record],
      (err, records) => {
        if (err) {
          console.error(err)
          reject(err)
        } else {
          resolve(records)
        }
      }
    )
  })
}

const del = (table, id) => {
  return new Promise((resolve, reject) => {
    api(table).destroy(
      id,
      (err, records) => {
        if (err) {
          console.error(err)
          reject(err)
        } else {
          resolve(records)
        }
      }
    )
  })
}

const patch = (table, record) => {
  return new Promise((resolve, reject) => {
    const { id, ...fields } = record

    api(table).update(
      id,
      fields,
      (err, record) => {
        if (err) {
          console.error(err)
          reject(err)
        } else {
          resolve(record)
        }
      }
    )
  })
}

const get = (table, id) => {
  return new Promise((resolve, reject) => {
    api(table).find(
      id,
      (err, record) => {
        if (err) {
          console.error(err)
          reject(err)
        } else {
          resolve(record)
        }
      }
    )
  })
}

const getAll = (table) => {
  return new Promise((resolve, reject) => {
    let allRecords = []

    api(table).select({
      maxRecords: 999
    }).eachPage((records, fetchNextPage) => {
      allRecords = [...allRecords, ...records]

      fetchNextPage()
    }, (err) => {
      if (err) {
        console.error(err)
        reject(err)
      } else {
        resolve(allRecords)
      }
    })
  })
}

export {
  del,
  get,
  getAll,
  patch,
  post
}
